import React from 'react'
import PropTypes from 'prop-types'
import { Link } from '@sainsburys-tech/fable'

const SupplierDeliveryInfo = ({ onClick, id }) => (
  <Link as='button' onClick={onClick} id={id}>
    A supplier will help us with this order
  </Link>
)

SupplierDeliveryInfo.propTypes = {
  /**
   * Function to call when the button is clicked
   */
  onClick: PropTypes.func,
  /**
   * Unique identifier for the button element
   */
  id: PropTypes.string
}

export default SupplierDeliveryInfo
